// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timetable_root__TKzS {
  position: relative;
  width: 100%;
  padding: var(--border-radius);
  padding-top: calc(var(--border-radius) - 15px);
  border-radius: var(--border-radius);
  color: var(--hsl-blue);
  background: var(--light-background);
  --timetable-accent-color: white;
  font-size: 15px;
  margin-bottom: 10px;
}

.timetable_icon_MnCF1 {
  width: 20px;
  height: 20px;
}

.timetable_validFrom_IDDa0 {
  padding: 0.313em 0.45em;
  color: black;
  font-size: 12.75px;
  display: flex;
  flex-wrap: wrap;
  gap: 0 0.6em;
}

.timetable_root__TKzS.timetable_a3_b967L {
  border-radius: 30px;
  padding: 15px 0px 30px 0px;
}

.timetable_root__TKzS.timetable_interval_v8KDE {
  padding-left: calc(var(--border-radius) / 2);
  padding-right: calc(var(--border-radius) / 2);
}

.timetable_root__TKzS.timetable_standalone_lLhYg {
  font-size: 22px;
}

.timetable_root__TKzS.timetable_summer_BPixk {
  background: white;
  --timetable-accent-color: var(--light-background);
}

.timetable_root__TKzS.timetable_greyscale_ErNHG {
  background: white;
  color: black;
  --timetable-accent-color: #eaeaea;
}

.timetable_root__TKzS.timetable_printable_o9vlr {
  width: auto;
  border-radius: 0;
}

.timetable_header_K6Hdg {
  padding: 0 0 0 0.4em;
}

.timetable_headerTitle_TM_K0 {
  font-size: 1.75em;
}

.timetable_componentName_PcwIL {
  padding: 0 0 0 0.205em;
  font-size: 1.875em;
}

.timetable_title_rI8nR {
  font-family: GothamRounded-Medium;
  white-space: nowrap;
  font-size: 0.9em;
}

.timetable_subtitle_Cuow2 {
  font-family: GothamRounded-Book;
  font-size: 0.9em;
}

.timetable_footnote_oUMBt {
  padding: 0.125em 0.625em;
  font-family: GothamXNarrow-Book;
  font-size: 0.813em;
}

.timetable_validity_chiHS {
  font-family: GothamXNarrow-Book;
  font-size: 0.75em;
  line-height: 1.1;
  letter-spacing: -0.025em;
  text-align: right;
  margin-left: auto;
  position: absolute;
  margin-top: -5px;
  top: calc(var(--border-radius));
  right: var(--border-radius);
}

.timetable_validity_chiHS .timetable_shortId_JnWRX {
  font-family: GothamRounded-Medium;
  font-size: 1.75em;
}

.timetable_address_oW2Qp {
  font-family: GothamRounded-Medium;
  font-size: 0.6rem;
  color: black;
  position: absolute;
  top: 1110px;
  right: var(--border-radius);
}

.timetable_validity_chiHS .timetable_title_rI8nR {
  font-family: GothamRounded-Medium;
}

.timetable_stopZone_EKaV1 {
  padding-left: 0.5em;
  margin-top: 0.875em;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.timetable_zoneTitle_tMNCK {
  font-size: 0.75em;
  line-height: 1.1;
  font-family: GothamRounded-Medium;
  white-space: nowrap;
  margin-right: 0.4em;
}

.timetable_zoneSubtitle_W2Iob {
  font-size: 0.75em;
  font-family: GothamRounded-Book;
}

.timetable_zone_Skkxk {
  position: relative;
  box-sizing: border-box;
  flex: none;
  width: 1.5em;
  height: 1.5em;
  color: white;
  background: var(--hsl-blue);
  border-radius: 50%;
}

.timetable_zoneLetter_mvs_Z {
  font-size: 1.25em;
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  line-height: 1;
  font-family: GothamRounded-Medium;
  text-transform: uppercase;
}

.timetable_printBtn_WIZAs {
  margin-left: 2rem;
  background-color: var(--hsl-blue);
  margin-top: 1.5rem;
  height: 2rem;
  width: fit-content;
  padding: 0 1rem 0 1rem;
  font-size: 0.9rem;
  border-radius: 10px;
  color: white;
  border: none;
}

.timetable_printBtn_WIZAs:hover {
  background-color: white;
  cursor: pointer;
  color: var(--hsl-blue);
  border: 1px solid var(--hsl-blue);
}

.timetable_coverPageMargin_Ee9MZ {
  top: 1160px;
}

@media print {
  .timetable_noPrint_L9BJ7,
  .timetable_noPrint_L9BJ7 * {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/timetable/timetable.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,8CAA8C;EAC9C,mCAAmC;EACnC,sBAAsB;EACtB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EAEjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF","sourcesContent":[".root {\n  position: relative;\n  width: 100%;\n  padding: var(--border-radius);\n  padding-top: calc(var(--border-radius) - 15px);\n  border-radius: var(--border-radius);\n  color: var(--hsl-blue);\n  background: var(--light-background);\n  --timetable-accent-color: white;\n  font-size: 15px;\n  margin-bottom: 10px;\n}\n\n.icon {\n  width: 20px;\n  height: 20px;\n}\n\n.validFrom {\n  padding: 0.313em 0.45em;\n  color: black;\n  font-size: 12.75px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0 0.6em;\n}\n\n.root.a3 {\n  border-radius: 30px;\n  padding: 15px 0px 30px 0px;\n}\n\n.root.interval {\n  padding-left: calc(var(--border-radius) / 2);\n  padding-right: calc(var(--border-radius) / 2);\n}\n\n.root.standalone {\n  font-size: 22px;\n}\n\n.root.summer {\n  background: white;\n  --timetable-accent-color: var(--light-background);\n}\n\n.root.greyscale {\n  background: white;\n  color: black;\n  --timetable-accent-color: #eaeaea;\n}\n\n.root.printable {\n  width: auto;\n  border-radius: 0;\n}\n\n.header {\n  padding: 0 0 0 0.4em;\n}\n\n.headerTitle {\n  font-size: 1.75em;\n}\n\n.componentName {\n  padding: 0 0 0 0.205em;\n  font-size: 1.875em;\n}\n\n.title {\n  font-family: GothamRounded-Medium;\n  white-space: nowrap;\n  font-size: 0.9em;\n}\n\n.subtitle {\n  font-family: GothamRounded-Book;\n  font-size: 0.9em;\n}\n\n.footnote {\n  padding: 0.125em 0.625em;\n  font-family: GothamXNarrow-Book;\n  font-size: 0.813em;\n}\n\n.validity {\n  font-family: GothamXNarrow-Book;\n  font-size: 0.75em;\n  line-height: 1.1;\n  letter-spacing: -0.025em;\n  text-align: right;\n  margin-left: auto;\n  position: absolute;\n  margin-top: -5px;\n  top: calc(var(--border-radius));\n  right: var(--border-radius);\n}\n\n.validity .shortId {\n  font-family: GothamRounded-Medium;\n  font-size: 1.75em;\n}\n\n.address {\n  font-family: GothamRounded-Medium;\n  font-size: 0.6rem;\n  color: black;\n  position: absolute;\n  top: 1110px;\n  right: var(--border-radius);\n}\n\n.validity .title {\n  font-family: GothamRounded-Medium;\n}\n\n.stopZone {\n  padding-left: 0.5em;\n  margin-top: 0.875em;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.zoneTitle {\n  font-size: 0.75em;\n  line-height: 1.1;\n  font-family: GothamRounded-Medium;\n  white-space: nowrap;\n  margin-right: 0.4em;\n}\n\n.zoneSubtitle {\n  font-size: 0.75em;\n  composes: zoneTitle;\n  font-family: GothamRounded-Book;\n}\n\n.zone {\n  position: relative;\n  box-sizing: border-box;\n  flex: none;\n  width: 1.5em;\n  height: 1.5em;\n  color: white;\n  background: var(--hsl-blue);\n  border-radius: 50%;\n}\n\n.zoneLetter {\n  font-size: 1.25em;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  text-align: center;\n  line-height: 1;\n  font-family: GothamRounded-Medium;\n  text-transform: uppercase;\n}\n\n.printBtn {\n  margin-left: 2rem;\n  background-color: var(--hsl-blue);\n  margin-top: 1.5rem;\n  height: 2rem;\n  width: fit-content;\n  padding: 0 1rem 0 1rem;\n  font-size: 0.9rem;\n  border-radius: 10px;\n  color: white;\n  border: none;\n}\n\n.printBtn:hover {\n  background-color: white;\n  cursor: pointer;\n  color: var(--hsl-blue);\n  border: 1px solid var(--hsl-blue);\n}\n\n.coverPageMargin {\n  top: 1160px;\n}\n\n@media print {\n  .noPrint,\n  .noPrint * {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `timetable_root__TKzS`,
	"icon": `timetable_icon_MnCF1`,
	"validFrom": `timetable_validFrom_IDDa0`,
	"a3": `timetable_a3_b967L`,
	"interval": `timetable_interval_v8KDE`,
	"standalone": `timetable_standalone_lLhYg`,
	"summer": `timetable_summer_BPixk`,
	"greyscale": `timetable_greyscale_ErNHG`,
	"printable": `timetable_printable_o9vlr`,
	"header": `timetable_header_K6Hdg`,
	"headerTitle": `timetable_headerTitle_TM_K0`,
	"componentName": `timetable_componentName_PcwIL`,
	"title": `timetable_title_rI8nR`,
	"subtitle": `timetable_subtitle_Cuow2`,
	"footnote": `timetable_footnote_oUMBt`,
	"validity": `timetable_validity_chiHS`,
	"shortId": `timetable_shortId_JnWRX`,
	"address": `timetable_address_oW2Qp`,
	"stopZone": `timetable_stopZone_EKaV1`,
	"zoneTitle": `timetable_zoneTitle_tMNCK`,
	"zoneSubtitle": `timetable_zoneSubtitle_W2Iob timetable_zoneTitle_tMNCK`,
	"zone": `timetable_zone_Skkxk`,
	"zoneLetter": `timetable_zoneLetter_mvs_Z`,
	"printBtn": `timetable_printBtn_WIZAs`,
	"coverPageMargin": `timetable_coverPageMargin_Ee9MZ`,
	"noPrint": `timetable_noPrint_L9BJ7`
};
module.exports = ___CSS_LOADER_EXPORT___;
